module.exports = __webpack_public_path__ + "static/media/Growth-banner.d0ac7fa3.jpg";